import { useEffect, useState } from 'react';

export const useIsDesktopSize = () => {
  const [isDesktopSize, setIsDesktopSize] = useState<boolean | undefined>(
    () => {
      if (typeof window === 'undefined') {
        return undefined;
      }
      return window.innerWidth >= 1024;
    },
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    function autoResize() {
      setIsDesktopSize(window.innerWidth >= 1024);
    }
    window.addEventListener('resize', autoResize);

    autoResize();

    return () => window.removeEventListener('resize', autoResize);
  }, []);

  return isDesktopSize;
};
